
import { http } from "@/helpers/http";
import Vue from 'vue'
import APP_URL from "@/helpers/urls";

const baseURL = APP_URL("utils");

export default {
    namespaced: true,
    state: {},

    actions: {
        async orderReturnPkgHistory({ state, commit, rootState }, payload) {
            try {
                let resp = await http.get(`${baseURL}/order-return-pkg-history?phoneNo=${payload.phoneNo}`);
                return resp.data;
            } catch (e) {
                console.log(e);
                return null;
            }
        },

        async orderHistoryWithShop({ state, commit, rootState }, payload) {
            try {
                let resp = await http.get(`${baseURL}/order-history-with-shop?phoneNo=${payload.phoneNo}&shopId=${payload.shopId}`);
                return resp.data;
            } catch (e) {
                console.log(e);
                return null;
            }
        }
    }
}